module.exports = __webpack_public_path__ + "img/banner-collect.37a9d4fb.jpg";